import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CheckCircle",
  "use": "CheckCircle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"CheckCircle\">\n  <g fill=\"currentColor\">\n    <path d=\"M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2zm-3 21l-6.8-6.7 1.9-1.9 4.8 4.8L23.2 9l1.9 1.9L13 23z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol